export default function initResumeUploadForm() {
    document.addEventListener( 'change', function( evt ) {
        if ( !evt.target || !evt.target.closest( '.attach-cv input[type=\'file\'][name^=\'resume\']' ) ) {
            return;
        }

        var input = evt.target;
        var container = input.closest( '.attach-cv' ); // se check file is there

        if ( input.files.length > 0 ) {
            var formData = new FormData();
            var size = input.files[ 0 ].size; // file size in bytes,

            var errormsg = input.dataset.errorMsgToobig;
            var successmsg = input.dataset.msgSuccess;
            var msgcontainer = input.closest( 'form' ).querySelector( '.messages' );
            msgcontainer.innerHTML = '';
            var process = container.querySelector( '.upload-process' );
            process.style.display = 'inline';

            if ( size > 1000000 ) {
                // 1000000 = +- 1MB
                msgcontainer.innerHTML = '<div class="alert alert-danger">' + errormsg + '</div>';
                return true;
            }

            formData.append( 'resume', input.files[ 0 ] );
            formData.append( 'json', 'yes' );

            http( input.dataset.uploadUrl, {
                method: 'POST',
                body: formData,
            } )
                .then( function( result ) {
                    process.style.display = 'none';
                    return result.json();
                } )
                .then( function( result ) {
                    msgcontainer.innerHTML = '';

                    if ( result.success ) {
                        var select = container.querySelector( 'select.select-cv' );
                        select[ select.options.length ] = new Option( result.fileName, result.resumeId );
                        select.value = result.resumeId;

                        msgcontainer.innerHTML = '<div class="alert alert-success">' + successmsg + '</div>';
                    } else if ( result.errors && result.errors.form ) {
                        errormsg = result.errors.form;
                        msgcontainer.innerHTML = '<div class="alert alert-danger">' + errormsg + '</div>';
                    }

                    input.value = '';
                } );
        }
    } );
}
